if (!customElements.get('runzie-countdown')) {
  customElements.define('runzie-countdown', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.timer);
      const value = (this.dataset.end || '').trim();
      const validFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(Z|[+-]\d{2}:\d{2})$/.test(value);
      this.deadline = validFormat ? Date.parse(value) : NaN;
      const valid = Number.isFinite(this.deadline);
      const editor = this.dataset.editor === 'true';
      const hint = this.querySelector('.runzie-countdown__hint');
      if (hint) hint.hidden = valid;
      this.hidden = !valid && !editor;
      if (!valid) return;
      const update = () => {
        const total = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
        const parts = { days: Math.floor(total / 86400), hours: Math.floor(total / 3600) % 24, minutes: Math.floor(total / 60) % 60, seconds: total % 60 };
        Object.entries(parts).forEach(([unit, value]) => {
          const node = this.querySelector('[data-unit="' + unit + '"]');
          if (node) node.textContent = String(value).padStart(2, '0');
        });
        this.hidden = total === 0 && this.dataset.hideExpired === 'true' && !editor;
        if (total === 0) clearInterval(this.timer);
        return total;
      };
      if (update() > 0) this.timer = setInterval(update, 1000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
  });
}
